export default __webpack_public_path__ + "static/media/cz.1b3452b8.svg";